import { gql } from "@apollo/client";
import { ROUTE_MANAGER_COMMUNITY_FRAGMENT } from "../queries";

export const ROUTE_MULTIPLAYER_GAMES_BY_ROUTE_SLUG = gql`
${ROUTE_MANAGER_COMMUNITY_FRAGMENT}
query routeMultiplayerGamesByRouteSlug($contains: [UUID], $slug: String!) {
  routeBySlug(slug: $slug) {
    id
    slug
    territory {
      id
      slug
    }
    routeManagers {
      nodes {
        id
        community {
          ...RouteManagerCommunityFragment
        }
      }
    }
    routeMultiplayerGames(
      filter: {players: {contains: $contains}, status: {equalTo: IN_PROGRESS}}
    ) {
      nodes {
        id
        createdByUserId
        players
        playersUsers {
          nodes {
            id
            name
            avatarUrl
            isTerritoryMentor
            username
            totalCredits
          }
        }
      }
    }
  }
}
`

export const CREATE_ROUTE_MULTIPLAYER_GAME = gql`
mutation createRouteMultiplayerGame($routeId: UUID!, $players:[UUID]!, $contains: [UUID]) {
  createRouteMultiplayerGame(
    input: { routeMultiplayerGame: { players: $players, routeId: $routeId } }
  ) {
    routeMultiplayerGame {
      id
      players
    }
    query {
      route(id: $routeId) {
        id
        routeMultiplayerGames(
          filter: {players: {contains: $contains}, status: {equalTo: IN_PROGRESS}}
        ) {
          nodes {
            id
            players
            playersUsers {
              nodes {
                id
                name
                avatarUrl
                isTerritoryMentor
                username
                totalCredits
              }
            }
          }
        }
      }
    }
  }
}
`;

export const USER_SPECIMENS_IN_MULTIPLAYER_GAME = gql`
  query UserSpecimensInMultiplayerGame($routeMultiplayerGameId: UUID!, $userId: UUID!) {
    userSpecimen(filter: {routeMultiplayerGameId: {equalTo: $routeMultiplayerGameId}, userId: {equalTo: $userId}}) {
      nodes {
        specimenId
      }
    }
  }
`;

export const ROUTE_MULTIPLAYER_GAME = gql`
${ROUTE_MANAGER_COMMUNITY_FRAGMENT}
query routeMultiplayerGame(
  $id: UUID!
  $userId: UUID!
) {
  routeMultiplayerGame(id: $id) {
    id
    status
    createdByUserId
    players
    playersUsers {
      nodes {
        id
        name
        avatarUrl
        isTerritoryMentor
        username
        totalCredits
      }
    }
    route {
      id
      slug
      name
      territory {
        id
        slug
      }
      routeManagers {
        nodes {
          id
          community {
            ...RouteManagerCommunityFragment
          }
        }
      }
    }
  }
  userSpecimen(
    filter: {
      routeMultiplayerGameId: { equalTo: $id }
      userId: { equalTo: $userId }
    }
  ) {
    totalCount
  }
  userSpecieses(
    filter: {
      routeMultiplayerGameId: { equalTo: $id }
      userId: { equalTo: $userId }
    }
  ) {
    totalCount
  }
  userCredits(
    filter: {
      routeMultiplayerGameId: { equalTo: $id }
      userId: { equalTo: $userId }
    }
  ) {
    totalCount
  }
}
`

export const CREATE_ROUTE_MULTIPLAYER_GAME_PLAYER = gql`
mutation createRouteMultiplayerGamePlayer(
  $newPlayerId: UUID!
  $routeMultiplayerGameId: UUID!
) {
  createRouteMultiplayerGamePlayer(
    input: {
      newPlayerId: $newPlayerId
      routeMultiplayerGameId: $routeMultiplayerGameId
    }
  ) {
    query {
      routeMultiplayerGame(id: $routeMultiplayerGameId) {
        id
        players
        playersUsers {
          nodes {
            id
            name
            avatarUrl
            isTerritoryMentor
            username
            totalCredits
          }
        }
        route {
          name
        }
      }
    }
  }
}
`;

export const DELETE_ROUTE_MULTIPLAYER_GAME_PLAYER = gql`
mutation deleteRouteMultiplayerGamePlayer($routeMultiplayerGameId: UUID!, $toDeletePlayerId: UUID!) {
  deleteRouteMultiplayerGamePlayer(
    input: {toDeletePlayerId: $toDeletePlayerId, routeMultiplayerGameId: $routeMultiplayerGameId}
  ) {
    query {
      routeMultiplayerGame(id: $routeMultiplayerGameId) {
        id
        players
        playersUsers {
          nodes {
            id
            name
            avatarUrl
            isTerritoryMentor
            username
            totalCredits
          }
        }
        route {
          name
        }
      }
    }
  }
}
`;

export const LEAVE_ROUTE_MULTIPLAYER_GAME = gql`
mutation leaveRouteMultiplayerGame($routeMultiplayerGameId: UUID!) {
  leaveRouteMultiplayerGame(
    input: {routeMultiplayerGameId: $routeMultiplayerGameId}
  ) {
    clientMutationId
  }
}
`;

export const TRANSFER_ROUTE_MULTIPLAYER_GAME_CONTROL = gql`
mutation transferRouteMultiplayerGameControl($routeMultiplayerGameId: UUID!, $newLeaderId: UUID!) {
  transferRouteMultiplayerGameControl(
    input: {routeMultiplayerGameId: $routeMultiplayerGameId, newLeaderId: $newLeaderId}
  ) {
    clientMutationId
    routeMultiplayerGame {
      id
      createdByUserId
    }
  }
}
`;
